import { sendEvent } from "../hooks/analytics";

export const sendProviderClickEvent = (
  label: string,
  globoID: string,
  providerName: string
) => {
  window.dataLayer.push({
    provider_name: providerName
  });

  sendEvent(
    "component_click",
    {
      provider_name: providerName,
      page_name_custom: label.replace(/\s+/g, "_").toLowerCase(),
      component_name: "escolha_sua_operadora",
      component_type: "button",
      component_item_link_redirect: "/provider.url"
    },
    {
      user_code: globoID,
      user_code_provider: "cadun"
    }
  );
};
